  <div class="map-container" style="height: 70vh;">
    <google-map
      height="100%"
      width="100%"
      [center]="center"
      [zoom]="zoom"
      [options]="mapOptions"
      (mapClick)="incidentSelected.emit(null)"
      >

      @for (incident of incidents(); track incident.incidentId) {
        @if (incident.location.latitude && incident.location.longitude) {
          @if (shouldPulse(incident)) {
            <map-marker
                [position]="getMarkerPosition(incident)"
                [options]="{
                  icon: getPulseIcon(incident),
                  zIndex: 1
                }">
            </map-marker>
          }
          
          <map-marker
              
              [position]="getMarkerPosition(incident)"
              [options]="{
                icon: getIconMarker(incident),
                zIndex: 2,
                title: '#BD00' + incident.incidentId + ': ' + incident.location.descriptionShort
              }"
              (mapClick)="onMarkerClick(incident)">
          </map-marker>
        }
      }

    </google-map>
  </div>
